import React, { useMemo } from "react"
import { useAutomationScriptsQuery } from "features/Automation/api/useAutomationQuery"

import AutomationDisplay from "features/Automation/components/AutomationDisplay.component"
import { Loader } from "shared/ui/Loader/Loader.component"

const AutomationContainer: React.FC = () => {
  const scriptsQuery = useAutomationScriptsQuery()

  // Filter out scripts from subfolders (those containing backslashes)
  const scripts = useMemo(
    () =>
      (scriptsQuery.data?.result.private ?? []).filter(
        (script: string) => !script.includes("\\")
      ),
    [scriptsQuery.data]
  )

  if (scriptsQuery.isLoading) {
    return (
      <div className="flex flex-col items-center justify-center h-full">
        <Loader fontSize={48} color="#36C3ED" />
        Loading available scripts...
      </div>
    )
  }

  if (scriptsQuery.isError) {
    return <></>
  }

  return (
    <div id="automation" className="flex flex-col h-full">
      <AutomationDisplay availableScripts={scripts} />
    </div>
  )
}

export default AutomationContainer
